
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M19.424 4.92h-.622V3.546C18.802 1.592 17.197 0 15.226 0H7.718c-1.97 0-3.575 1.592-3.575 3.547v1.372h-.567C1.605 4.92 0 6.511 0 8.466v5.72c0 1.955 1.605 3.547 3.576 3.547h.562v4.496c0 .975.802 1.771 1.785 1.771h11.089c.983 0 1.785-.796 1.785-1.77v-4.497h.627c1.971 0 3.576-1.592 3.576-3.547v-5.72c0-1.955-1.605-3.547-3.576-3.547zM5.492 3.546c0-1.214.998-2.204 2.221-2.204h7.503c1.224 0 2.222.99 2.222 2.204v1.372H5.492V3.547zm11.951 18.692a.433.433 0 01-.431.428H5.923a.433.433 0 01-.431-.428v-7.416h11.951v7.416zm4.203-8.048a2.217 2.217 0 01-2.222 2.204h-.622v-1.572h.893a.671.671 0 100-1.343H3.145a.671.671 0 100 1.343h.998v1.572h-.567a2.217 2.217 0 01-2.222-2.204v-5.72c0-1.214.998-2.204 2.222-2.204h15.848c1.224 0 2.222.99 2.222 2.204v5.72z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M7.61 18h7.78c.339 0 .61-.222.61-.5s-.271-.5-.61-.5H7.61c-.339 0-.61.222-.61.5s.276.5.61.5zM15.394 20H7.61c-.34 0-.611.222-.611.5s.271.5.61.5h7.78c.339 0 .61-.222.61-.5s-.271-.5-.606-.5z","fill":"#4A4A4A"}}),_c('path',{attrs:{"d":"M19.256 8h-1.512c-.413 0-.744.222-.744.5s.33.5.744.5h1.512c.413 0 .744-.222.744-.5s-.33-.5-.744-.5z","fill":"#595959"}})])])
          )
        }
      }
    